import { isAxiosError, type AxiosInstance } from "axios";
import type { TipoArquivo } from "./tipo-arquivo";
import type { Arquivo } from "./arquivo";
import type { StatusArquivo } from "./status-arquivo";

type SearchRequest = {
    id?: string
    id_in?: string[]
    tipo?: TipoArquivo
    tipo_in?: TipoArquivo[]
    status?: StatusArquivo
    status_in?: StatusArquivo[]
    offset?: number
    limit?: number
}

export class ArquivoRepository {
    constructor(
        private api: AxiosInstance
    ) { }
    
    async upload(file: File, tipo: TipoArquivo): Promise<Arquivo> { 
        try {
            const body = new FormData()
            body.set('tipo', tipo)
            body.append('arquivo', file)

            console.log({file})

            const { data } = await this.api.post<Arquivo>(`/arquivos/upload`, body)
            
            return data
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.error)
            }
            throw error
        }
    }
    async search(request: SearchRequest): Promise<Arquivo[]> {
        try {
           

            const { data } = await this.api.get<Arquivo[]>(`/arquivos/search`, {
                params: request
            })

            return data
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.error)
            }
            throw error
        }
    }
    async searchOne(request: Omit<SearchRequest, 'limit'>): Promise<Arquivo> {
        try {


            const { data } = await this.api.get<Arquivo>(`/arquivos/search-one`, {
                params: request
            })

            return data
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.error)
            }
            throw error
        }
    }
    async processar() {
        try {
            await this.api.get<void>(`/arquivos/processar`)
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.error)
            }
            throw error
        }
    }
}